export class FinanceDisputeDialogModel {
    constructor(
        public disputedByOps: any,
        public disputedByFinance: any,
        public disputedAmount: any,
        public id: any,
        public disableUndo: any,
        public remarks: any
    ) {}
}